import { first, without } from 'lodash';

import { ITableHeadCellMapping } from './index';

const shouldHide = (map: ITableHeadCellMapping, remainingSpace: number) => {
    return remainingSpace < 0 || remainingSpace - map.width < 0;
};
const sortMappingByPriority = ((obj1, obj2) => obj1.priority - obj2.priority);
const sortMappingByIndex = ((obj1, obj2) => obj1.index - obj2.index);

export function calculateHiddenMapping (headersMapping: ITableHeadCellMapping[], remainingSpace): ITableHeadCellMapping[] {
    let tippingPoint = false;
    // Everything after the tipping point is hidden, to prevent field 8 (shorter) to appear after field 7 (longer) no longer fits
    const hidden = headersMapping
        .sort(sortMappingByPriority)
        .reduce(
            (original: ITableHeadCellMapping[], map) => {
                if (map.header.props.checkbox) {
                    remainingSpace -= map.width;
                    return original;
                }
                if (map.header.props.hidden) {
                    // If the field is defined as hidden we simply add it
                    original.push(map);
                    return original;
                }
                if (tippingPoint) {
                    original.push(map);
                } else {

                    if (shouldHide(map, remainingSpace)) {
                        original.push(map);
                        tippingPoint = true;
                    } else {
                        remainingSpace -= map.width;
                    }
                }
                return original;
            },
            []
        )
        .sort(sortMappingByIndex)
    ;

    return hidden;
}

export function calculateMapping (headersMapping: ITableHeadCellMapping[], remainingSpace): {
    visible: ITableHeadCellMapping[],
    hidden: ITableHeadCellMapping[],
} {
    const hiddenMapping = calculateHiddenMapping(headersMapping, remainingSpace);

    const visible = headersMapping
        .sort(sortMappingByPriority)
        .reduce(
            (original: ITableHeadCellMapping[], map) => {
                if (original.length === (headersMapping.length - hiddenMapping.length)) {
                    // make sure we do not show more visible than we should (tipping point)
                    return original;
                }
                if (map.header.props.hidden) {
                    // if its hidden, we simply ignore it
                    return original;
                }
                const hidden = shouldHide(map, remainingSpace);
                if (!hidden) {
                    original.push(map);
                    remainingSpace -= map.width;
                }
                return original;
            },
            []
        )
        .sort(sortMappingByIndex)
    ;

    if (visible.length === 1 && visible.filter((c) => c.header.props.checkbox).length === 1) {
        // Only checkboxes are displayed
        const firstNotCheckbox = first(headersMapping.filter((c) => !c.header.props.checkbox).sort(sortMappingByPriority));
        if (firstNotCheckbox) {
            return {
                visible: [...visible, firstNotCheckbox],
                hidden: without(hiddenMapping, firstNotCheckbox),
            };
        }
    }

    if (visible.length === 0) {
        // Make sure we always show the first column, even if it does not fit
        const firstHeader = first(headersMapping.sort(sortMappingByPriority));
        if (!firstHeader) {
            return {
                visible: [],
                hidden: hiddenMapping,
            };
        }
        return {
            visible: [firstHeader],
            hidden: hiddenMapping,
        };
    }
    if (!visible) {
        return {
            visible: [],
            hidden: hiddenMapping,
        };
    }
    return {
        visible,
        hidden: hiddenMapping,
    };
}
